
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage/friend_coupon",
      function () {
        return require("private-next-pages/mypage/friend_coupon/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage/friend_coupon"])
      });
    }
  